@if (
  {
    row: columnData | async,
  };
  as $
) {
  <div
    class="flex justify-content-between"
    (click)="executeAction('rowAction', $.row)"
  >
    <div class="flex align-items-end" class="mr-3 cursor-pointer">
      {{
        $.row.name_primary_language.length > 24
          ? ($.row.name_primary_language | slice: 0 : 24) + '...'
          : $.row.name_primary_language
      }}
    </div>
    <div class="flex align-items-end">
      @if (isFuture) {
        <p-tag
          styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap"
        >
          FUTURE
        </p-tag>
      } @else {
        @if ($.row.status.toUpperCase() === 'Active'.toUpperCase()) {
          <p-tag
            styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap"
            severity="success"
          >
            {{ $.row.status }}</p-tag
          >
        }
        @if ($.row.status.toUpperCase() === 'InActive'.toUpperCase()) {
          <p-tag
            styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap"
          >
            {{ $.row.status }}</p-tag
          >
        }
      }
    </div>
  </div>
}
